const grid = {
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
  containerWidths: {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140,
  },
  gutterWidth: 30,
};

export default grid;
